/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import Header from "../../../components/common/layout/Header";
import AllTours from "../../../components/passenger/tours/AllTours";
import Banner from "../../../components/passenger/tours/Banner";
import { useEffect, useState } from "react";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";

const Tours = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>(null)
    const [searchList, setSearchList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [search, setSearch] = useState<string>("")
    const { t } = useTranslation('common');
    useSitemap();

    const getVisitPlaces = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.tours}`);

            if (res && res?.status === 200) {
                setData(res?.data)
                setSearchList(res?.data)
                setLoading(false);
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while feching places data", error);
        }
    };

    useEffect(() => {
        !!lang && getVisitPlaces();
    }, [lang])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.tour.title")}</title>
                <meta name="description" content={t("seo_friendly.tour.desc")} />
            </Helmet>
            <div className="w-full h-full relative bg-white dark:bg-bgDarkDull">
                <Header type="passenger" />
                <Banner searchList={searchList} setData={setData} setSearch={setSearch} search={search} />

                <div className="w-full h-full container" id="home">
                    <AllTours data={data} loading={loading} searchList={searchList} setSearch={setSearch} search={search} isError={isError} />
                </div>
            </div>
        </>
    );
};

export default Tours;